module.exports = __webpack_public_path__ + "img/colazione_1.50b67dbf.jpeg";